export default "__VITE_ASSET__8$rE6eyt__"